"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _validationUtils = require("AudienceTargetingUIComponents/utils/validationUtils");

var FilterTextInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterTextInput, _PureComponent);
  (0, _createClass2.default)(FilterTextInput, null, [{
    key: "defaultProps",
    get: function get() {
      return {
        type: 'text'
      };
    }
  }, {
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        value: _react.PropTypes.string,
        size: _react.PropTypes.string,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        operator: _react.PropTypes.string,
        type: _react.PropTypes.string
      };
    }
  }]);

  function FilterTextInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterTextInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterTextInput).call(this, props));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValidationMessage = _this.getValidationMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterTextInput, [{
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "validateInput",
    value: function validateInput(value) {
      var type = this.props.type;
      var isInputValid = type === 'url' ? (0, _validationUtils.isValidUrl)(value) : Boolean(value.length);
      this.setState({
        isInputValid: isInputValid
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      var value = e.target.value;
      onBlur(e);
      this.validateInput(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        isInputValid: true
      });
      this.props.onChange(e);
    }
  }, {
    key: "getValidationMessage",
    value: function getValidationMessage() {
      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          type = _this$props.type;
      var msg = type === 'url' ? 'enterValidUrl' : 'mustHaveValue';
      var validationConfig;

      if (labelConfig.validations) {
        validationConfig = labelConfig.validations[msg];
      }

      if (this.state.isInputValid) return '';
      return validationConfig || _I18n.default.text(this.getLangKey("validations." + msg));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          labelConfig = _this$props2.labelConfig,
          value = _this$props2.value,
          size = _this$props2.size,
          type = _this$props2.type,
          operator = _this$props2.operator;
      var isInputValid = this.state.isInputValid;
      var placeholderConfig;

      if (labelConfig.placeholders) {
        placeholderConfig = labelConfig.placeholders[type];
      }

      var placeholder = placeholderConfig || _I18n.default.text(this.getLangKey("placeholders." + type));

      if (operator === 'STR_STARTS_WITH' && !placeholderConfig) {
        placeholder = _I18n.default.text(this.getLangKey('placeholders.startsWith'));
      }

      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input " + size,
        error: !isInputValid,
        validationMessage: this.getValidationMessage()
      }, _react.default.createElement(_UITextInput.default, {
        className: 'targeting-option__contains-input',
        placeholder: type === 'text' ? null : placeholder,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: value || ''
      }));
    }
  }]);
  return FilterTextInput;
}(_react.PureComponent);

exports.default = FilterTextInput;
module.exports = exports.default;